module.exports = __webpack_public_path__ + "img/Snipaste_2023-07-21_18-00-20.0a27a16b.png";